import React from 'react';
import './CommentCard.css';

function CommentCard({ comment }) {
  return (
    <div className="comment-card">
      <div className="comment-header">
        <div className="user-info">
          <img src={comment.avatar} alt={comment.username} className="user-avatar" />
          <span className="username">{comment.username}</span>
        </div>
        <div className="comment-time">{comment.date}</div>
      </div>
      <div className="comment-content">
        {comment.content}
      </div>
      <div className="comment-footer">
        <div className="comment-rating">
          {'★'.repeat(comment.rating)}
        </div>
        <div className="comment-course">{comment.course}</div>
      </div>
    </div>
  );
}

export default CommentCard; 